import React from "react";
import Task from "./Task";
import "../styles/Column&Task.css";
import boardsSlice from "../redux/boardsSlice";
import { useDispatch, useSelector } from "react-redux";
import API from "../api";

export default function Column({ colIndex }) {
  const dispatch = useDispatch();
  const boards = useSelector((state) => state.boards);
  const board = boards.find((board) => board.isActive === true);
  const col = board.columns.find((col, i) => i === colIndex);

  const handleOnDrop = async (e) => {
    const { prevColIndex, taskIndex } = JSON.parse(e.dataTransfer.getData("text"));

    if (colIndex !== prevColIndex) {
      let updatedBoard = JSON.parse(JSON.stringify(board));
      const taskToMove = updatedBoard.columns[prevColIndex].tasks.splice(taskIndex, 1)[0];
      taskToMove.status = board.columns[colIndex].name;
      updatedBoard.columns[colIndex].tasks.push(taskToMove);

      try {
        await API.put(`/boards/${board._id}`, updatedBoard);
        const res = await API.get("/boards");
        dispatch(boardsSlice.actions.setBoards(res.data));
      } catch (err) {
        console.error(err);
      }
    }
  }

  const handleOnDragOver = (e) => {
    e.preventDefault()
  }

  return (
    <div className="column" onDrop={handleOnDrop} onDragOver={handleOnDragOver}>
      <p className="col-name heading-S">
        {col.name} ({col.tasks.length})
      </p>
      {col.tasks.map((task, index) => {
        return (
          <Task key={index} taskIndex={index} colIndex={colIndex} />
        );
      })}
    </div>
  );
}
